import { getSimpleDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../../../store/rootReducer';

export const CategorySelectionContentSelector = getSimpleDataSelector((state: RootState) => state.categoryCatalog);
